import styled, { css, keyframes } from 'styled-components'

const showSaldo = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`

export const GimplusTitle = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  img {
    max-width: 170px;
    height: 100%;
  }
`

export const GimplusFilterContainer = styled.div`
  display: flex;
  align-items: center;
`

export const ButtonExportar = styled.button`
  ${({ theme }) => css`
    border-radius: 4px;
    padding: 12px 16px;
    margin: -4px 0px 0px 8px;
    max-height: 42px;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    display: flex;
    align-items: center;
    transition: all 400ms;
    background: transparent;
    border: 2px solid ${theme.colors.primary};
    color: ${theme.colors.primary};
    cursor: pointer;

    &:hover {
      border-color: #4a4a4a;
      color: #4a4a4a;
    }
  `}
`

export const SaldoMessage = styled.div`
  position: relative;

  h3 {
    font-size: 30px;
    margin-top: 4px;
  }

  strong {
    transition: all ease-in-out 400ms;
    animation: ${showSaldo} 1s;
  }

  p {
    font-size: 18px;
    margin-right: 40px;
  }

  @media (max-width: 1170px) {
    p {
      font-size: 16px;
    }
    h3 {
      font-size: 24px;
    }
  }
`
